<template>
    <v-dialog v-model="dialog" max-width="40%" @keydown.esc="cancel">
        <v-card>
            <v-card-title class="headline">
                {{ $t('actions.reseller.storeSupplier.title') }}
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <p>{{ $t('actions.reseller.storeSupplier.p1') }}</p>
                <p>{{ $t('actions.reseller.storeSupplier.p2') }}</p>
                <p v-if="reseller">
                    <strong>Parceiro: {{ reseller.trade_name }}</strong>
                </p>
                <p>{{ $t('actions.reseller.storeSupplier.p3') }}</p>
            </v-card-text>
            <v-card-actions>
                <v-btn class="col" text @click="dialog = false">
                    {{ $t('actions.reseller.storeSupplier.close') }}
                </v-btn>
                <v-divider vertical=""></v-divider>
                <v-btn
                    class="col"
                    color="green darken-1"
                    text
                    @click="save"
                    :loading="saving"
                >
                    {{ $t('actions.reseller.storeSupplier.save') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data: () => {
        return {
            dialog: false,
            reseller: undefined,
            loading: true,
            sorting: true,
            saving: false,
        }
    },

    watch: {
        dialog() {
            if (this.dialog === false) {
                this.reseller = undefined
            }
        },
    },

    methods: {
        open(reseller) {
            this.dialog = true
            this.reseller = reseller
        },

        async save() {
            this.saving = true
            let res = await this.reseller.storeSupplier(this.reseller.id)
            this.saving = false
            this.dialog = false

            if (!res) return

            this.$emit('modelChanged', this.reseller)
            this.$bus.$emit(
                'notify',
                'success',
                this.$t('actions.reseller.storeSupplier.success'),
            )
        },
    },
}
</script>

<style></style>
